import React from 'react';
import { btoa , toUnicode } from '../../../cryptographic/crypto';
import { getCookie } from '../../utility/cookies';

function ContactAgent({ setContactAgent, contactAgent, teams, socket,botInfo,prefLang}) {
    const sendMessage = (e) => {
        // console.log("safdasfsffffff",e)
        let sendData = {
            text : toUnicode(e.title),
            payload: toUnicode(e.payload)
        }
        socket.emit(btoa(["user-send",sendData]));
        setContactAgent(false)
    }
    const currentLang = getCookie('prefLang')
    return (
        <>
            {
                contactAgent ?
                    <div className="drawer-overlay" onClick={() => setContactAgent(false)}></div>
                    : null
            }
            <div className={`leave-message-wrapper ${contactAgent ? "show-leave-form" : ""}`}>
                <div className="green-mark"></div>
                <div className="drawer-header">
                    {botInfo?.data?.mobileAppConfig?.talkToAgentSelectDepart ? botInfo?.data?.mobileAppConfig?.talkToAgentSelectDepart?.[prefLang] : "Please choose department for Agent"}
                </div>
                <div className="drawer-body">
                    <div className="agent-list-wrapper">
                        {
                            teams?.map(dept=>{
                                return <div className="agent-item" onClick={(e)=>sendMessage(dept)}><i className="bot icon-headset-1"></i><span>{dept.title}</span></div>
                        
                            })
                        }
                        {/* <div className="agent-item"><i className="bot icon-headset-1"></i><span>Civil Status Division</span></div>
                        <div className="agent-item"><i className="bot icon-headset-1"></i><span>Social Registry of Mauritius</span></div>
                        <div className="agent-item"><i className="bot icon-headset-1"></i><span>Ministry of Education, Tertiary Education, Science and Technology</span>	</div>
                        <div className="agent-item"><i className="bot icon-headset-1"></i><span>Ministry of Commerce and Consumer Protection</span></div>
                        <div className="agent-item"><i className="bot icon-headset-1"></i><span>Assay Office</span></div>
                        <div className="agent-item"><i className="bot icon-headset-1"></i><span>Ministry of Land Transport and Light Rail</span></div> */}
                    </div>
                </div>
            </div>
        </>
    )
}
export default ContactAgent;
